<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Cadastro de Frota - Cavalo</app-titulo>
      <div class="header-buttons">
        <app-botao
          type="primario"
          text="Cadastrar Cavalo"
          icon="assets/add.svg"
          (click)="navegarCavalo()"></app-botao>
        <app-botao
          type="upload"
          text="Enviar Planilha"
          icon="assets/add-excel.svg"
          (fileSelected)="uploadArquivo($event)"></app-botao>
        <app-botao
          type="secundario"
          [ariaPlaceholder]="'Baixar Marca'"
          width="40px"
          icon="assets/download.svg"
          (click)="this.downloadExcel()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Cavalos</div>
        <div class="align-button">
          <form [formGroup]="form" (ngModelChange)="getCavalo()">
            <div class="table-filters">
              <app-input
                label="Placa:"
                placeholder="Pesquisar "
                name="TX_PLCA_CAVA"
                formControlName="TX_PLCA_CAVA"
                width="100%"></app-input>
              <app-input
                label="Marca:"
                width="100%"
                placeholder="Pesquisar"
                name="TX_MDLO_CAVA"
                formControlName="TX_MDLO_CAVA"></app-input>
            </div>
          </form>
        </div>
      </div>
      <app-loader [isLoading]="isLoading"></app-loader>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>
  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        label="Placa:"
        placeholder="Pesquisar "
        name="TX_PLCA_CAVA"
        formControlName="TX_PLCA_CAVA"
        width="100%"></app-input>
      <app-input
        label="Marca:"
        width="100%"
        placeholder="Pesquisar"
        name="TX_MDLO_CAVA"
        formControlName="TX_MDLO_CAVA"></app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
  <app-subtitulo *ngIf="!tableData.length"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
</app-layout>
<app-loader [isLoading]="isLoading"></app-loader>
